import type { Product } from "~/types";

// Ported verbatim from /tmp/fnd-design-pkg/b2b-foundation/project/components/data.jsx
// Mapping: cat → category, your → price, weight → unit, color → colorHex,
// badges:["NEW"|"EXCLUSIVE"] → stickers:["new"|"exclusive"], numeric stock →
// "out" (0) | "low" (<=18) | "in" (otherwise).
export const PRODUCTS: Product[] = [
  // Coffee — beans / blends
  {
    id: "NOIR-1K",
    name_ua: "Кава Бленд Noir Bloom, 1 кг",
    name_en: "Noir Bloom Blend, 1kg",
    category: "beans",
    origin: "Blend",
    unit: "1 kg",
    retail: 1931,
    price: 1545,
    stock: "in",
    colorHex: "#E56B9E",
    stickers: ["new"],
  },
  {
    id: "LAS-1K",
    name_ua: "Кава Колумбія Las Moras, 1 кг",
    name_en: "Colombia Las Moras, 1kg",
    category: "beans",
    origin: "Colombia",
    unit: "1 kg",
    retail: 2132,
    price: 1705,
    stock: "in",
    colorHex: "#14110C",
    stickers: ["exclusive"],
  },
  {
    id: "NOIR-250",
    name_ua: "Кава Бленд Noir Bloom, 250 г",
    name_en: "Noir Bloom Blend, 250g",
    category: "beans",
    origin: "Blend",
    unit: "250 g",
    retail: 498,
    price: 395,
    stock: "in",
    colorHex: "#C53838",
  },
  {
    id: "ARB-250",
    name_ua: "Ефіопія Арбегона, 250 г",
    name_en: "Ethiopia Arbegona, 250g",
    category: "beans",
    origin: "Ethiopia",
    unit: "250 g",
    retail: 598,
    price: 478,
    stock: "in",
    colorHex: "#F5F3EE",
    stickers: ["new"],
  },
  {
    id: "LAS-250",
    name_ua: "Колумбія Las Moras, 250 г",
    name_en: "Colombia Las Moras, 250g",
    category: "beans",
    origin: "Colombia",
    unit: "250 g",
    retail: 548,
    price: 435,
    stock: "low",
    colorHex: "#1D4AFF",
  },
  {
    id: "ESP-BLND-1K",
    name_ua: "Бленд Espresso Classico, 1 кг",
    name_en: "Espresso Classico Blend, 1kg",
    category: "beans",
    origin: "Blend",
    unit: "1 kg",
    retail: 1680,
    price: 1340,
    stock: "in",
    colorHex: "#6B3914",
  },
  {
    id: "DECAF-250",
    name_ua: "Деканф Колумбія, 250 г",
    name_en: "Decaf Colombia, 250g",
    category: "beans",
    origin: "Colombia",
    unit: "250 g",
    retail: 612,
    price: 490,
    stock: "out",
    colorHex: "#2EAE5A",
    stickers: ["decaf"],
  },
  {
    id: "INNO-1K",
    name_ua: "Inno Seasonal, 1 кг",
    name_en: "Inno Seasonal, 1kg",
    category: "beans",
    origin: "Kenya",
    unit: "1 kg",
    retail: 2440,
    price: 1950,
    stock: "low",
    colorHex: "#F08A3E",
    stickers: ["exclusive"],
  },

  // Ground / drip
  {
    id: "DRIP-7",
    name_ua: "Дріпи Колумбія Sugar Cane Decaf, 7 шт",
    name_en: "Drip Bags Sugar Cane Decaf, 7pcs",
    category: "ground",
    origin: "Colombia",
    unit: "7 × 12 g",
    retail: 295,
    price: 235,
    stock: "in",
    colorHex: "#2EAE5A",
  },
  {
    id: "CAPS-10",
    name_ua: "Капсули Espresso, 10 шт",
    name_en: "Espresso Capsules, 10pcs",
    category: "ground",
    origin: "Blend",
    unit: "10 capsules",
    retail: 220,
    price: 175,
    stock: "in",
    colorHex: "#8A5BC6",
  },

  // Equipment
  {
    id: "GR-MAHL",
    name_ua: "Кавомолка Mahlkönig X54",
    name_en: "Mahlkönig X54 Grinder",
    category: "equipment",
    unit: "1 шт",
    retail: 54800,
    price: 48900,
    stock: "low",
  },
  {
    id: "MCH-LM",
    name_ua: "Еспрессо-машина La Marzocco Linea",
    name_en: "La Marzocco Linea Espresso",
    category: "equipment",
    unit: "1 шт",
    retail: 428000,
    price: 392000,
    stock: "low",
  },

  // Accessories
  {
    id: "CUP-250",
    name_ua: "Чашка капучино, 250 мл (6 шт)",
    name_en: "Cappuccino cup 250ml, pack of 6",
    category: "accessories",
    unit: "6 шт",
    retail: 840,
    price: 670,
    stock: "in",
  },
  {
    id: "FLT-V60",
    name_ua: "Фільтри V60 (100 шт)",
    name_en: "V60 paper filters, 100pcs",
    category: "accessories",
    unit: "100 шт",
    retail: 210,
    price: 168,
    stock: "in",
  },

  // Training
  {
    id: "TR-BARIS",
    name_ua: "Тренінг Бариста І (4 год)",
    name_en: "Barista I Training (4h)",
    category: "training",
    unit: "4 год",
    retail: 3200,
    price: 2560,
    stock: "in",
  },
];
